import { useTranslation } from 'react-i18next'
import { BsFileEarmarkArrowDown } from 'react-icons/bs'
import IconEye from '../Icons/IconEye'

interface Props {
  fileUrl?: string | null
}

/**
 * Download + view actions for a generated invoice PDF. Shared by the admin
 * invoices table and the super admin transactions table.
 */
const InvoiceFileActions = ({ fileUrl }: Props) => {
  const { t } = useTranslation()

  if (!fileUrl) return null

  return (
    <div className='flex items-center justify-center gap-4 min-w-[80px]'>
      <a
        href={fileUrl}
        download
        rel='noopener noreferrer'
        title={t('download')}
        className='text-lightGray hover:text-primaryBlue transition-colors'
      >
        <BsFileEarmarkArrowDown className='text-xl' />
      </a>
      <a
        href={fileUrl}
        target='_blank'
        rel='noopener noreferrer'
        title={t('view')}
        className='cursor-pointer group'
      >
        <IconEye />
      </a>
    </div>
  )
}

export default InvoiceFileActions
